import { atom } from "recoil";
import { IGetBookingsSummaryReturn } from "../../api/services";
import { IBookingsApiFilter } from "../../api/types";

export const bookingsFilterState = atom<IBookingsApiFilter | undefined>({
    key: 'bookingsFilterState',
    default: undefined
});

export const summaryState = atom<IGetBookingsSummaryReturn['summary'] | undefined>({
    key: 'summaryState',
    default: undefined
})
